module.exports = __webpack_public_path__ + "static/media/400116_01.8c687b46.png";